import React, { useState, useMemo } from 'react';
import GenericTabs from 'components/navigation/Tabs/Tabs';
import { GetAssureDetailsResponse } from 'api/actor';
import PersonGeneralInfo from './PersonGeneralInfo';
import PersonAdministrativeDocuments from './PersonAdministrativeDocuments';

interface PersonInfosProps {
  personDetails: GetAssureDetailsResponse;
  personId: string;
}

const PersonInfos: React.FC<PersonInfosProps> = ({ personDetails, personId }) => {
  const [activeTab, setActiveTab] = useState<number | string>(1);

  const tabs = useMemo(
    () => [
      {
        id: 1,
        label: 'Informations personnelles',
        content: <PersonGeneralInfo personDetails={personDetails} />
      },
      {
        id: 2,
        label: 'Pi\u00e8ces administratives',
        content: <PersonAdministrativeDocuments personId={personId} />
      }
    ],
    [personDetails, personId]
  );

  return (
    <div className="border rounded-xl px-4 py-2">
      <GenericTabs defaultTab={activeTab} onChange={setActiveTab}>
        {tabs.map((tab) => (
          <GenericTabs.Item
            key={tab.id}
            label={tab.label}
            value={tab.id}
            className="flex justify-center font-semibold w-full"
          />
        ))}
        {tabs.map((tab) => (
          <GenericTabs.Content key={tab.id} value={tab.id}>
            <div className="p-4">{tab.content}</div>
          </GenericTabs.Content>
        ))}
      </GenericTabs>
    </div>
  );
};

export default PersonInfos;
